// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"b8dda5bc","403":"946a89f6","453":"ea1a144b","484":"a9a55b96","551":"868310a5","672":"f446746d","842":"ae2388b0","869":"681bb601","974":"59ca168a"}[chunkId] + ".chunk.js";
};